export default __webpack_public_path__ + "static/media/amd.ccc39200.png";